import {createFileRoute} from '@tanstack/react-router';

import Register from '@/anonymous/views/Register';

export const Route = createFileRoute('/(anonymous)/register')({
  component: Register
});
